import React, { useEffect, useState, Fragment, useRef } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { getOrder } from "services"
import { Checkbox } from "components"
import KtOrderCardDropDown from "./KtOrderCardDropDown"
import KtOrderCheckoutButton from "./KtOrderCheckoutButton"
import KtOrderCardItems from "./KtOrderCardItems"
import KtOrderCardCombos from "./KtOrderCardCombos"
import KtOrderHeader from "./KtOrderHeader"
import { checkIsOrderEditable } from "utils"
import classes from "./KtOrderCard.module.scss"

const KtOrderCard = props => {
  const {
    tableOrder,
    setTableOrders,
    tableDetails,
    isSelected,
    showEditButton,
    setSelectedOrders
  } = props

  const i18n = useTranslation()[1]

  const [openDropdown, setOpenDropdown] = useState(false)
  const [isOrderEditable, setIsOrderEditable] = useState(false)
  const [paymentDetail, setPaymentDetail] = useState(null)
  const [subPaymentItems, setSubPaymentItems] = useState(null)

  const unmount = useRef(false)

  const handleSelect = () => {
    if (subPaymentItems === null) return

    setSelectedOrders(prev => {
      const object = { ...prev }

      const exists = !!object[tableOrder._id]

      if (exists) {
        delete object[tableOrder._id]
      } else {
        object[tableOrder._id] = {
          ...tableOrder,
          subPaymentItems:
            subPaymentItems[tableOrder._id]
        }
      }

      return object
    })
  }

  const getOrderSubPaymentItems = async () => {
    try {
      const bypassIsViewed = true

      const response =
        await getOrder(
          tableOrder._id,
          bypassIsViewed
        )

      if (unmount.current) return

      if (!response.paymentDetail) return

      setPaymentDetail(
        response.paymentDetail
      )

      const subPaymentItems = {}

      response.paymentDetail.subPaymentItems.forEach(subPaymentItem => {
        const orderItemId = subPaymentItem.orderItemId

        subPaymentItems[orderItemId] = {
          subPaymentItemId: subPaymentItem._id,
          paymentStatus: subPaymentItem.paymentStatus
        }
      })

      setSubPaymentItems(subPaymentItems)
    } catch (err) {
      console.log(err)
    }
  }

  const validateOrder = async () => {
    const isEditable = !isOrderSplited

    if (!isEditable) return

    try {
      const result =
        await checkIsOrderEditable(tableOrder)

      if (unmount.current) return

      setIsOrderEditable(result)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    unmount.current = false

    validateOrder()

    getOrderSubPaymentItems()

    return () => unmount.current = true
  }, [])

  const isOrderSplited =
    tableOrder.items.some(ti =>
      subPaymentItems?.[ti._id]?.paymentStatus === "paid"
    )

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["card"],
        isLtr && classes["card-ltr"]
      )}
    >
      <Checkbox
        checked={isSelected}
        onChange={handleSelect}
      />
      <div className={classes["order"]}>
        <KtOrderHeader
          tableOrder={tableOrder}
          isOrderSplited={isOrderSplited}
        />
        <KtOrderCardItems
          tableOrder={tableOrder}
        />
        <KtOrderCardCombos
          tableOrder={tableOrder}
        />
      </div>
      <div className={classes["right"]}>
        {
          showEditButton &&
          <Fragment>
            <KtOrderCheckoutButton
              tableOrder={tableOrder}
              tableDetails={tableDetails}
              subPaymentItems={subPaymentItems}
            />
            <KtOrderCardDropDown
              isOrderEditable={isOrderEditable}
              isOrderSplited={isOrderSplited}
              subPaymentItems={subPaymentItems}
              tableDetails={tableDetails}
              tableOrder={tableOrder}
              setTableOrders={setTableOrders}
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              paymentDetail={paymentDetail}
            />
            <div />
          </Fragment>
        }
      </div>
    </div>
  )
}

export default KtOrderCard